import { render, staticRenderFns } from "./TicketAcaoObjetoList.vue?vue&type=template&id=6b584df7"
import script from "./TicketAcaoObjetoList.vue?vue&type=script&lang=js"
export * from "./TicketAcaoObjetoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports